import AttachFileIcon from "@mui/icons-material/AttachFile";
import CancelIcon from "@mui/icons-material/Cancel";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import {
  Avatar,
  Box,
  Divider,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import { getDatabase, off, onValue, ref } from "firebase/database";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { allIcons } from "../../assets";
import appcolors from "../../constants/Colors";
import { receiveMessage, sendMessage } from "./SendMessage";
import SnackbarAlert from "../SnackBar";
import Loader from "../Loader";
import { useLocation } from "react-router-dom";

const style = {
  incoming: {
    p: "8px 10px",
    backgroundColor: "#F1F1F1",
    borderRadius: "12px",
    alignSelf: "flex-start",
    maxWidth: "70%",
    wordBreak: "break-word",
  },
  outgoing: {
    p: "8px 10px",
    color: appcolors.white,
    backgroundColor: appcolors.primary,
    borderRadius: "12px",
    alignSelf: "flex-end",
    maxWidth: "70%",
    wordBreak: "break-word",
  },
  searchField: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 2,
      "& .MuiOutlinedInput-notchedOutline": {
        border: `2px solid #F3F3F3`,
        boxShadow: "none",
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        border: `2px solid #F3F3F3`,
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        border: `2px solid #F3F3F3`,
      },
    },
  },
};

function MessageBox() {
  const { selectedBranch } = useSelector((state) => state.selectedBranch);
  console.log(selectedBranch, "selectedBranchselectedBranch");
  const { selectedChat } = useSelector((state) => state.activeChat);
  const { user } = useSelector((state) => state.user);
  const [msgValue, setMsgValue] = useState("");
  const [allMessages, setAllMessages] = useState([]);
  const [imgUrl, setImgUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const messageContainerRef = useRef(null);
  const imageRef = useRef();
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });

  useEffect(() => {
    if (selectedChat) {
      try {
        const messagesRef = ref(
          getDatabase(),
          `messages/${selectedBranch[0]}/${selectedChat?.user?._id}`
        );

        const handleDataSnapshot = (snapshot) => {
          var data = snapshot.val();
          console.log(data, "datadatadatadata");
          if (data !== null) {
            let tempArr = [];
            Object.keys(data).forEach((key) => {
              const item = data[key];

              tempArr.push({
                sendBy: item?.sender,
                ReceivedBy: item?.receiver,
                msg: item?.msg,
                time: item?.time,
                attachmentUrl: item?.attachmentUrl ? item?.attachmentUrl : null,
              });
            });
            if (tempArr.length > 0) {
              setAllMessages(tempArr);
            }

            data = null;
            tempArr = [];
          } else {
            setAllMessages([]);
          }
        };

        if (messageContainerRef.current) {
          setTimeout(() => {
            messageContainerRef.current.scrollTop =
              messageContainerRef.current.scrollHeight;
          }, 1500);
        }

        onValue(messagesRef, handleDataSnapshot);

        // Cleanup the listener when component updates with a new selectedUser
        return () => {
          off(messagesRef, "value", handleDataSnapshot);
        };
      } catch (error) {
        console.log(error, "errorerrorerror");
      }
    }
  }, [selectedChat]);

  const handleSend = () => {
    if (msgValue) {
      setImgUrl(null);
      sendMessage(msgValue, selectedBranch[0], selectedChat?.user?._id, imgUrl)
        .then((res) => {
          setMsgValue("");
        })
        .catch((err) => {
          setMsgValue("");

          alert(err);
        });
      receiveMessage(
        msgValue,
        selectedBranch[0],
        selectedChat?.user?._id,
        imgUrl
      )
        .then(() => {
          setMsgValue("");
        })
        .catch((err) => {
          setMsgValue("");

          alert(err);
        });
    }
  };
  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };
  const handleImageChange = (event) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    formData.append("upload_preset", "tuytnefv");
    formData.append("cloud_name", "dgooan4ix");

    axios({
      method: "post",
      url: "https://api.cloudinary.com/v1_1/dgooan4ix/upload",
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((res) => {
        setIsLoading(false);
        setImgUrl(res?.data?.secure_url);
      })
      .catch((error) => {
        setIsLoading(false);
        handleSnackbarVal(true, "error", error?.message);
      });
  };

  return (
    <Paper
      sx={{
        p: 2,
        borderRadius: "10px",
        position: "relative",
        // height: "100%",
      }}
    >
      <Loader isloading={isLoading} />
      {selectedChat ? (
        <>
          <Stack direction={"row"} alignItems={"center"} gap={2}>
            <Avatar
              sx={{ borderRadius: "25%" }}
              src={
                selectedChat?.logoImage
                  ? selectedChat?.logoImage
                  : selectedChat?.user?.image
              }
              alt={`${
                selectedChat?.logoImage
                  ? selectedChat?.logoImage
                  : selectedChat?.user?.image
              }-image`}
            />
            <Box>
              <Typography
                variant="body1"
                fontSize={"1rem"}
                fontWeight={"bold"}
                fontFamily={"Metropolis"}
              >
                {selectedChat?.businessName
                  ? selectedChat?.businessName
                  : selectedChat?.user?.username}
              </Typography>
              {/* <Stack direction={"row"} alignItems={"center"} gap={0.5}>
                <FiberManualRecordIcon
                  htmlColor="#68D391"
                  sx={{ fontSize: "0.875rem" }}
                />
                <Typography variant="body2" fontSize={"0.75rem"}>
                  Online
                </Typography>
              </Stack> */}
            </Box>
          </Stack>

          <Divider sx={{ my: 1 }} />
          <Stack
            p={1}
            gap={1}
            height={"51vh"}
            overflow={"auto"}
            ref={messageContainerRef}
            sx={{
              "&::-webkit-scrollbar": {
                // display:"none",
                width: "4px",
                height: "8px",
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: appcolors.primary,
                borderRadius: "4px",
              },
              "&::-webkit-scrollbar-thumb:hover": {
                backgroundColor: appcolors.secondary,
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: appcolors.lightGrey,
              },
            }}
          >
            {allMessages?.map((vallllll, ind) => {
              return (
                <Box
                  key={ind}
                  sx={
                    vallllll.sendBy !== selectedBranch[0]
                      ? style.incoming
                      : style.outgoing
                  }
                >
                  {vallllll?.attachmentUrl && (
                    <img
                      src={vallllll?.attachmentUrl}
                      style={{
                        height: "250px",
                        width: "100%",
                        marginTop: "5px",
                        borderRadius: "10px",
                        objectFit: "contain",
                      }}
                    />
                  )}
                  <Typography variant="body2">{vallllll.msg}</Typography>
                </Box>
              );
            })}
          </Stack>

          {imgUrl !== null && (
            <Box
              style={{
                width: "150px",
                height: "150px",
                position: "relative",
                marginLeft: "35px",
                marginBottom: "5px",
              }}
            >
              <Box
                onClick={() => setImgUrl(null)}
                style={{
                  position: "absolute",
                  height: "25px",
                  width: "25px",
                  zIndex: 999,
                  right: 4,
                  top: 4,
                  borderRadius: 100,
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <CancelIcon style={{ fontSize: "25px" }} />
              </Box>
              <img
                src={imgUrl}
                style={{ width: "100%", height: "100%", borderRadius: 10 }}
              />
            </Box>
          )}

          <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
            <TextField
              sx={style.searchField}
              fullWidth
              onChange={(e) => setMsgValue(e.target.value)}
              value={msgValue}
              placeholder="Type a message"
              onKeyUp={(e) => e.key === "Enter" && handleSend()}
              InputProps={{
                startAdornment: (
                  <Box mr={1}>
                    <AttachFileIcon
                      sx={{ transform: "rotate(45deg)", cursor: "pointer" }}
                      onClick={() => imageRef.current.click()}
                    />
                    <input
                      type="file"
                      style={{ height: 0, width: 0, visibility: "hidden" }}
                      ref={imageRef}
                      onChange={handleImageChange}
                      accept={"image/*"}
                    />
                  </Box>
                ),
                endAdornment: (
                  <Box ml={1} sx={{ cursor: "pointer" }} onClick={handleSend}>
                    <img src={allIcons.sendIcon} alt="send-icon" width={20} />
                  </Box>
                ),
              }}
            />
          </Box>
        </>
      ) : (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography sx={{ color: "black" }}>
            Select a user for conversation
          </Typography>
        </Box>
      )}
      <SnackbarAlert
        snackbarProps={snackbarProps}
        handleCloseSnackbar={handleCloseSnackbar}
      />
    </Paper>
  );
}

export default MessageBox;
